var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("i", {
    staticClass: "v-icon notranslate mdi mdi-eye-outline v-icon--link",
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }